<template>
  <component
    :is="component"
    :class="rootClassName"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script>

export default {
  name: 'ListItem',

  props: {
    component: {
      type: [ Object, String ],
      default: 'li'
    },
    indented: Boolean,
    selected: Boolean
  },

  computed: {
    rootClassName () {
      return [
        this.$style.root,
        { [ this.$style.indented ]: this.indented },
        { [ this.$style.selected ]: this.selected }
      ]
    }
  }
}

</script>

<style module>

.root {
	@apply 
		block 
		px-4
    py-2
		font-medium
		text-secondary;
}

.root > * {
  min-width: 32px;
}

.indented {
	padding-left: calc(1.5rem + 32px);
	@apply
    text-dull-dark
		py-2
}

.selected {
  @apply 
		text-primary;
}

</style>
